import { Link } from 'react-router-dom';
import { stats } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20security%20theme%20with%20warm%20coral%20and%20deep%20charcoal%20gradients%2C%20flowing%20geometric%20shapes%2C%20soft%20glowing%20orbs%20representing%20secure%20connections%2C%20minimalist%20futuristic%20atmosphere%2C%20dark%20background%20with%20warm%20amber%20and%20coral%20accents%2C%20no%20text%2C%20clean%20sleek%20design%2C%20professional%20tech%20branding%20aesthetic%2C%20subtle%20particle%20effects%2C%20depth%20and%20dimension&width=1920&height=900&seq=hero-bg-2026-kaiyun&orientation=landscape"
        alt="开云登录安全登录服务"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            开云登录 &mdash; 安全快速
            <br />
            值得信赖的登录服务
          </h1>
          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed">
            开云登录官方入口，提供安全、快速、稳定的登录体验。
            支持多设备一键开云登录，保障账户安全，享受极速访问服务。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3 rounded-md text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              立即开始使用
            </Link>
            <Link
              to="/category/shiyong-zhinan"
              className="px-8 py-3 rounded-md text-base font-medium border border-background-50/50 text-background-50 hover:bg-white/15 transition-all whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>

        <div className="max-w-4xl mx-auto mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-300 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}